<template>
  <div class="d-flex justify-content-center">
    <div class="flex-column">
      <div class="div-carousel-start">
        <h1 class="display-1 text-white">Welcome to Onyxia</h1>
        <br />
        <p class="text-warning font-custom m-4">
          We are here to provide you with the best in private server, we are
          constantly growing and we would love to have you with us! Enjoy and
          join our discord, stay tuned for updates, drops and much more!
        </p>
        <br />
        <button class="glow-on-hover mb-5">
          <a
            href="https://onyxia-rsps.com/files/onyxia-launcher.jar"
            class="text-black"
            download
          >
            Play Now
          </a>
        </button>
      </div>
      <br />
      <div class="div-carousel">
        <p class="text-warning font-custom">
          Drag your mouse to see more images
        </p>
        <carousel
          :per-page="3"
          :paginationEnabled="false"
          :autoplayLoop="true"
          :autoplay="true"
          :autoplayTimeout="3200"
          :autoplayHoverPause="true"
        >
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/1.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/2.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/3.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/4.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/5.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/6.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/7.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/8.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/9.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/10.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/11.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/12.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/13.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/14.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/15.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/16.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/17.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/18.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/19.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/20.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/21.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/22.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/23.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/24.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/25.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/26.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/27.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/28.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/29.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/30.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/31.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/32.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/33.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/34.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/35.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/36.png"
          /></slide>
          <slide
            data-index="0"
            data-name="MySlideName"
            @slideclick="handleSlideClick"
            ><img src="../assets/pictures/37.png"
          /></slide>
        </carousel>
      </div>
      <!---<a href="" target="_blank"><img src="../assets/discord.png" alt="Discord" /></a>--->
      <!---<a href="" target="_blank"><img src="../assets/youtube.png" alt="Youtube" /></a>--->
      <!---<a href="" target="_blank"><img src="../assets/facebook.png" alt="Discord" /></a>--->
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "MainBody",
  components: {
    Carousel,
    Slide,
  },
};
</script>

<style scoped>
.div-carousel-start {
  width: 100%;
}
.div-carousel {
  margin-top: 40px;
  width: 100%;
}
img {
  margin-top: 10px;
  width: 80%;
  border: 1px solid rgba(255, 255, 255, 0.589);
}
.font-custom {
  font-size: 26px;
}
a {
  color: black;
  font-size: 30px;
}
a:hover {
  font-size: 32px;
  text-decoration: none;
}
.glow-on-hover {
  width: 220px;
  height: 50px;
  border: none;
  outline: none;
  color: #fff;
  background: #111;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
  font-size: 30px;
}

.glow-on-hover:before {
  content: "";
  background: linear-gradient(
    45deg,
    #000000,
    #ffffff,
    #ffffff,
    #000000,
    #000000,
    #ffffff,
    #020202,
    #ff0000,
    #ffffff
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}
@media only screen and (max-width: 1280px) {
  img {
    width: 90%;
  }
}
@media only screen and (max-width: 600px) {
}
</style>